import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as NotificationQuestIcon } from 'icons/components/notificationQuest.svg';

export default class Quest extends MainComponent {
    static propTypes = {
        textTooltip: PropTypes.string,
        size: PropTypes.number,
        maxWidth: PropTypes.number,
    };
    static defaultProps = {
        textTooltip: "",
        size: 16,
        maxWidth: 400,
    };

    render() {
        const { textTooltip, size, maxWidth } = this.props;

        return (
            <div className="flex" data-tooltip={textTooltip} data-tooltip-max-width={maxWidth}>
                <NotificationQuestIcon width={size} height={size} />
            </div>
        );
    }

}


